import React, { useEffect, useMemo } from 'react'

import { useDelayTimer, useInstData } from 'Tyan/public/hooks'

import DesktopToolbar from './DesktopToolbar'
import PhoneToolbar from './PhoneToolbar'

const TopToolbar = ({ isPhone, pageNum: pageNumProp, totalPageNum, onPageSelected, onChgNumPerPage, ...props }) => {
	pageNumProp = pageNumProp || 1
	totalPageNum = totalPageNum || 1

	const { me: { state: { pageNum }, setState } } = useInstData(undefined, useMemo(() => ({ state: { pageNum: pageNumProp } }), []))

	const minPage = 1, maxPage = totalPageNum

	const { doDelay: delayPage } = useDelayTimer(500)
	const handlePageSelected = v => {
		v = Math.max(Math.min(maxPage, v), minPage)
		delayPage(() => onPageSelected(v), v != pageNumProp)
		setState({ pageNum: v })
	}

	const { doDelay: delayNPP } = useDelayTimer(500)
	const handleNumPerPageChange = (v) => delayNPP(() => onChgNumPerPage(Math.max(v, 1)))

	// const handleShow = () => setPageNum(pageNumProp)

	useEffect(() => { setState({ pageNum: pageNumProp || 1 }) }, [minPage, maxPage, pageNumProp])

	const calcedProps = { pageNum, minPage, maxPage, onPageSelected: handlePageSelected, onChgNumPerPage: handleNumPerPageChange }
	const Comp = isPhone ? PhoneToolbar : DesktopToolbar
	return <Comp {...props} {...calcedProps} />
}

export default TopToolbar